import React, {useEffect, useState} from "react";
import {t} from "../../../shared-services/translate";
import BottomDefaultNotification from "./Bottom.defaultNotification";
import {useSelector} from "../../../shared-services/redux-tiny";

const BottomShipCostInfo = () => {
  const name = "BottomShipCostInfo";
  const {bottomNotification} = useSelector(state => state.topLayer);
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (bottomNotification?.name === name) setOptions(bottomNotification?.options);
  }, [bottomNotification]);

  return <>
    <BottomDefaultNotification name={name}>
      {t("cart.delivery_info.delivery_cost_range", options)}
    </BottomDefaultNotification>
  </>;
};

export default BottomShipCostInfo;
